export const muiOutlinedInput = {
    styleOverrides:{
        input:{
            padding: '10px',
        }
    }
}